export enum ConditionFeatureState {
  On = 'on',
  Off = 'off',
}

export interface AppInstalled {
  id?: string;
  isInstalled?: boolean;
}
export interface CustomThemeComponent {
  compType: string;
  isWithCustomTheme: boolean;
}

export interface Condition {
  ignoreDesignPanel?: boolean;
  specName?: string;
  specValue?: string;
  siteImagesExist?: boolean;
  tpaInstalled?: AppInstalled;
  repeaterItem?: ConditionFeatureState;
  adminPage?: ConditionFeatureState;
  membersInstalled?: ConditionFeatureState;
  superAppInstalled?: AppInstalled;
  dataMode?: ConditionFeatureState;
  devMode?: ConditionFeatureState;
  provisioned?: ConditionFeatureState;
  multilingualMode?: ConditionFeatureState;
  interactionMode?: ConditionFeatureState;
  lightboxMode?: ConditionFeatureState;
  fullWidthLightboxMode?: ConditionFeatureState;
  myDesigns?: ConditionFeatureState;
  myWidgets?: ConditionFeatureState;
  educationMode?: ConditionFeatureState;
  refComponentSupported?: ConditionFeatureState;
  staticPagesOverLimit?: ConditionFeatureState;
  pageIsConnectable?: ConditionFeatureState;
  customMenuEnabled?: ConditionFeatureState;
  customTheme?: CustomThemeComponent;
}
